<template>
  <div class="no-navbar-layout" :class="{ desktop: $isDesktop }">
    <nav class="nav-bar">
      <pu-homepage-link>
        <img
          src="@/assets/images/pitchup-favicon.svg"
          alt=""
          width="41"
          height="36"
        />
        <span class="menu-chevron"
          ><span class="chevron-l" /><span class="chevron-r"
        /></span>
        <span class="sr-only">Menu</span>
      </pu-homepage-link>
    </nav>
    <slot class="nuxt-content" />

    <footer :class="{ desktop: $isDesktop }">
      <img
        loading="lazy"
        src="@/assets/images/pitchup-logo.png"
        class="logo"
        alt=""
        width="90"
        height="79"
      />

      <ul class="aboutus">
        <li>
          <img
            src="@/assets/images/tick-circle-blue.svg"
            width="16"
            height="16"
            alt=""
          />
          <translate>No booking fees</translate>
        </li>
        <li>
          <img
            src="@/assets/images/tick-circle-blue.svg"
            width="16"
            height="16"
            alt=""
          />
          <translate :tt="{ numberOfMillion: 6, numberOfCountries: 200 }">
            Trusted by {numberOfMillion}m holidaymakers from
            {numberOfCountries}+ countries
          </translate>
        </li>
        <li>
          <img
            src="@/assets/images/tick-circle-blue.svg"
            width="16"
            height="16"
            alt=""
          />
          <translate>
            You'll receive an email confirmation and will be able to view your
            booking 24/7
          </translate>
        </li>
      </ul>

      <feefo-badge />
      <footer-links class="footer-nav" />
      <version />
      <copyright />
    </footer>
  </div>
</template>

<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'

@Component({
  setup() {
    const authStore = useAuthStore()
    const searchWizardStore = useSearchWizardStore()
    return {
      authStore,
      searchWizardStore,
    }
  },
})
class LayoutNoNavbar extends Vue {
  get currentYear() {
    const d = new Date()
    return d.getFullYear()
  }
}

export default toNative(LayoutNoNavbar)
</script>

<style scoped>
.no-navbar-layout {
  min-height: 100dvh;
}

.nav-bar {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  padding: 0.8em 1.5em;
  margin: 0 auto;
}

.nav-bar img {
  width: auto;
  height: 2em;
}

footer {
  background-color: #eff6ff;
  padding: 1.4em;
}

.logo {
  width: 5em;
  height: auto;
  margin: 0 auto 1em;
  display: flex;
}

li {
  font-size: var(--small);
  margin: 0 0 1em;
  padding: 0 0 0 1.3em;
  position: relative;
}

.aboutus img {
  display: inline-block;
  width: 1.2em;
  height: 1.2em;
  position: absolute;
  left: -0.4em;
}

.footer-nav {
  margin: 1em -1.4em 0;
}
.footer-nav :deep(a) {
  font-size: var(--small);
  padding: 1.3em 1em;
}

/* desktop & tablet */
footer.desktop {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
</style>
